export default "__VITE_ASSET__aMUkntb5__"